import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ProjectService } from '../../shared/services/project/project.service';
import { CustomViewsService } from '../../features/custom-views/services/custom-views.service';
import { AddCustomViewDialog } from './add-custom-view-dialog/add-custom-view-dialog';

@Injectable({ providedIn: 'root' })
export class CustomViewsUiService {
  private readonly dialog = inject(MatDialog);
  private readonly router = inject(Router);
  private readonly projectService = inject(ProjectService);
  private readonly customViewsService = inject(CustomViewsService);

  openAddViewDialog(): void {
    const currentProject = this.projectService.currentProject();
    if (!currentProject) return;

    this.dialog
      .open(AddCustomViewDialog)
      .afterClosed()
      .subscribe((name?: string) => {
        if (!name) return;

        const newView = {
          name,
          projectId: currentProject.id,
          sections: [],
        };

        this.customViewsService.saveView(newView).subscribe(async (saved) => {
          await this.router.navigate(['/custom-views', saved.id]);
        });
      });
  }
}
